import { render, staticRenderFns } from "./adyen_tos_viewer.vue?vue&type=template&id=4b0f2c8a&"
import script from "./adyen_tos_viewer.vue?vue&type=script&lang=js&"
export * from "./adyen_tos_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports